export const PageHero = ({ eyebrow, title, intro, image, imageAlt, imageClassName = "" }) => {
  return (
    <section className="relative pt-12 lg:pt-20 pb-16 lg:pb-24 bg-brand-cream overflow-hidden">
      <div className="absolute -top-24 -right-32 w-[28rem] h-[28rem] rounded-full bg-brand-soft blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 fade-up">
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase font-semibold text-brand">
              <span className="w-8 h-px bg-brand" /> {eyebrow}
            </span>
          )}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-5 text-brand-ink">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-lg lg:text-xl text-brand-mute max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5 fade-up fade-up-delay-2">
            <div className="relative">
              <div className="absolute -inset-3 bg-brand-soft rounded-[2rem] rotate-[-2deg]" />
              <img
                src={image}
                alt={imageAlt}
                className={`relative w-full h-[360px] lg:h-[460px] object-cover rounded-[1.75rem] shadow-xl ${imageClassName}`}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
